import axios from "axios";
import helpers from "../helpers";

const API_URL = helpers.API_ENDPOINT;

class ApiService {
    get(data, url) {
        return axios
            .get(API_URL + url, {
                params: data
            })
            .then((response) => {
                return response.data;
            });
    }
    post(data, url) {
        if (data.id) {
            return axios
                .put(API_URL + url + '/' + data.id, data, {
                })
                .then((response) => {
                    return response.data;
                });
        } else {
            return axios
                .post(API_URL + url, data, {
                })
                .then((response) => {
                    return response.data;
                });
        }
    }
    show(url) {
        return axios
            .get(API_URL + url, {
            })
            .then((response) => {
                return response.data;
            });
    }
    put(data, url) {
        return axios
            .put(API_URL + url, data, {
            })
            .then((response) => {
                return response.data;
            });
    }
    delete(url) {
        return axios.delete(API_URL + url, {
        })
            .then((response) => {
                return response.data;
            });
    }
}

export default new ApiService();
